import React from "react";

const AuthorizationPersonalInformationSection = () => {
  return (
    <section className="privacy-policy-section">
      <div className="privacy-policy-subcontainer">
        <h1 className="pp-title">
          Autorización Tratamiento de Datos Personales
          <sup style={{ fontSize: "1rem" }}>
            {" "}
            <a
              href="#note1"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              1
            </a>
          </sup>
        </h1>
        <p className="pp-txt">
          Autorizo de manera previa, expresa e informada a Cavca Ltda., sus
          filiales, empresas que compartan en por lo menos 50% socios con Cavca
          Ltda., compañías aliadas, o a quienes representen sus derechos u
          ostenten en el futuro la calidad de acreedor, cesionario (en adelante
          Las Empresas) o cualquier calidad frente a mi o frente a la persona
          que represento (como titulares de la información), para que para que,
          directamente o a través de terceros (quienes adquirirán la calidad de
          encargados), traten mi información personal, de seguros, financiera,
          crediticia, comercial, sensible, privada, semiprivada, profesional,
          laboral, de aportes de seguridad social integral y parafiscales,
          contenida en medios físicos, electrónicos o digitales, en los
          siguientes términos:
        </p>
        <h3 className="pp-subtitle-small">I. FINALIDAD</h3>
        <p className="pp-txt">Autorizo a Las Empresas para:</p>
        <ol className="pp-list">
          <li className="pp-list-elm">
            Que soliciten, almacenen, consulten, compartan, enriquezcan,
            informen, reporten, rectifiquen, procesen, modifiquen, actualicen,
            aclaren, retiren o divulguen, ante operadores de información, riesgo
            y de seguridad social y parafiscales, o ante cualquier otra entidad
            que maneje o administre bases de datos en Colombia y/o en el
            exterior
            <sup>
              {" "}
              <a
                href="#note2"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                2
              </a>
            </sup>
            , todo lo referente a mi información de seguros, financiera,
            comercial y crediticia y aquella relacionada con la liquidación o
            pago de aportes al sistema de seguridad social y parafiscales
            (presente, pasada y futura) y aquella relacionada con los derechos y
            obligaciones originados en virtud de cualquier contrato celebrado u
            operación que haya llegado o llegare a celebrar o realizar, con
            cualquiera de Las Empresas.
          </li>
          <li className="pp-list-elm">
            Que suministren, consulten, verifiquen y compartan la información de
            seguros, financiera, comercial, y crediticia, con contratistas o
            cualquier otra entidad nacional o extranjera que preste servicios de
            verificación o análisis de administración de riesgo; y actualicen mi
            información, de acuerdo con el análisis realizado.
          </li>
          <li className="pp-list-elm">
            Que consulten, soliciten o verifiquen la información sobre mis
            activos (tales como vehículos, inmuebles, bicicletas, equipo
            industrial etc.), bienes o derechos ante entidades públicas o
            privadas, o que se encuentren en buscadores públicos, redes sociales
            o publicaciones físicas o electrónicas en Colombia o en el exterior.
            Esto, con el fin de prevenir el lavado de activos, la financiación
            del terrorismo, así como detectar el fraude, corrupción, actividades
            ilegales y poder tarifar correctamente los productos que me desean
            ofrecer.
          </li>
          <li className="pp-list-elm">
            Que accedan a información del dispositivo móvil y computador
            personal a través de cookies. Autorizo que almacenen información de
            conexión, id, aplicaciones instaladas, información del rendimiento
            de la aplicación con la finalidad de mejorar la experiencia de
            nuestros canales digitales, permitir el acceso a diversas
            funcionalidades y realizar una mejor gestión de la seguridad para
            detectar, prevenir e investigar actividades sospechosas.
          </li>
          <li className="pp-list-elm">
            Me contacten con el fin de suministrar información de productos,
            servicios, legal, comercial, de seguridad, cobranza de obligaciones,
            con fines de actualización de datos o de cualquier otra índole,
            directamente y/o a través de sus proveedores, por cualquier medio,
            pero sin limitarse a: correos electrónicos, vía telefónica,
            mensajería instantánea, notificaciones push y a través de redes
            sociales.
          </li>
          <li className="pp-list-elm">
            Que me ofrezcan y presten sus productos o servicios a través de
            cualquier medio o canal, para mi beneficio y de acuerdo con el
            perfil de la audiencia que quieran alcanzar.
          </li>
          <li className="pp-list-elm">
            Que consulten, soliciten, verifiquen, investiguen y gestionen
            información de mi ubicación y datos de contacto para efectos de
            notificaciones con fines de seguridad, cobranza, ofrecimiento de
            beneficios y ofertas comerciales.
          </li>
          <li className="pp-list-elm">
            Efectúen investigaciones comerciales, encuestas, analítica de datos,
            estadísticas, análisis de riesgos, de mercado, de seguros,
            interbancario y financiero, y la construcción de información
            agregada (enriquecimiento de mi perfil como prospecto y/o cliente)
            que podrá compartir con clientes y terceros. La presente finalidad
            incluye la posibilidad de contactarme o contactar a mi representada
            para estos fines.
          </li>
          <li className="pp-list-elm">
            Reportar mi comportamiento en el cumplimiento de mis obligaciones a
            centrales de riesgo.
          </li>
          <li className="pp-list-elm">
            Transmitir y almacenar mis datos personales dentro y fuera del país,
            a consecuencia de un contrato, ley o vínculo lícito que así lo
            requiera y para almacenar mi información en servicios de computación
            en la nube.
          </li>
        </ol>
        <h3 className="pp-subtitle-small">II. DECLARACIÓN</h3>
        <p className="pp-txt">
          Declaro que he sido informado sobre el derecho:
        </p>
        <ol className="pp-list">
          <li className="pp-list-elm">
            Que tengo a conocer, actualizar y rectificar mis datos personales.
          </li>
          <li className="pp-list-elm">
            A ser informado sobre el tratamiento que se ha dado a mis datos
            personales.
          </li>
          <li className="pp-list-elm">
            A revocar la autorización otorgada y/o solicitar la supresión de mis
            datos parcial o totalmente.
          </li>
          <li className="pp-list-elm">
            A aceptar o negar cualquier propuesta comercial que me sea
            realizada.
          </li>
          <li className="pp-list-elm">
            A eliminar total o parcialmente alguna de las finalidades
            autorizadas en este documento.
          </li>
        </ol>
        <p className="pp-txt">
          Para resolver sus dudas al respecto de esta autorización y/o modificar
          la autorización otorgada, comuníquese con nuestro oficial de
          cumplimiento al correo <strong>jpuerta@cavca.com.co</strong>.
        </p>
        <div className="pp-obs">
          <p className="pp-txt">
            <sup id="note1">1</sup>Esta Autorización reemplaza totalmente
            cualquier documento anterior, con el fin de tener un único documento
            claro y concreto.
          </p>
          <p className="pp-txt">
            <sup id="note2">2</sup>Tales como las siguientes, pero sin limitarse
            a: RUT, RUES, RUNT, SIMIT, RUP, Bases de Datos de Cámaras de
            Comercio, Bases de Datos de las Alcaldías Municipales, Garantías
            Mobiliarias, Registro de Instrumentos Públicos, perfiles de redes
            sociales y Bases de Datos de Carácter Privado en la cual los
            Titulares han autorizado para la presentación de oferta de bienes y
            servicios adicionales.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AuthorizationPersonalInformationSection;
